import React, {SyntheticEvent} from "react";
import {observer} from "mobx-react";
import _ from "lodash";

import "./thresholds.scss";

import {Dropdown, Form} from "semantic-ui-react";

import {Kiwis, TimeSeries} from "../../../../../../../kiwis";
import {ThresholdsConfiguration} from "../../../../../../../config/chart-configuration";
import {SelectOptionConfiguration} from "../../../../../../../core/config/select-option-configuration";

interface ThresholdsProps {
    kiwis: Kiwis;
    timeSeries: TimeSeries;
    compact: boolean;
    config: ThresholdsConfiguration;
}

@observer
export class Thresholds extends React.Component<ThresholdsProps, any> {
    constructor(props: ThresholdsProps) {
        super(props);

        this.renderLabel = this.renderLabel.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount(): void {
        const {kiwis, timeSeries, config} = this.props;
        if (!kiwis.selectedStationId.get()) {
            return;
        }
        const station = kiwis.stations.get(kiwis.selectedStationId.get());
        if (!station) {
            return;
        }

        const options = config.values.filter((opt) => {
            // check if there is a value present on station for this threshold
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const value = station[opt.value];
            return opt.type === "value" && value != null;
        });
        // remember available thresholds
        kiwis.setAvailableThresholds(timeSeries.id, options);

        const selectedValues = options.filter((v) => {
            // noinspection PointlessBooleanExpressionJS
            return v.active === true;
        }).map((opt) => opt.value);

        // remember selected thresholds
        kiwis.setSelectedThresholds(timeSeries.id, selectedValues);
    }

    onChange(event: SyntheticEvent, data: any) {
        const {kiwis, timeSeries, config} = this.props;

        // store selection in kiwis store
        if (!Array.isArray(data.value)) {
            return;
        }

        // Sort selected thresholds in order of available threshold values
        // This ensures the same array index of thresholds key and value
        const thresholds: string[] = [];
        config.values.forEach((opt: SelectOptionConfiguration) => {
            if (data.value.includes(opt.value)) {
                thresholds.push(opt.value);
            }
        });

        kiwis.setSelectedThresholds(timeSeries.id, thresholds);
    }

    render() {
        const {kiwis, timeSeries, compact} = this.props;

        if (!kiwis.selectedStationId.get()) {
            return null;
        }
        const station = kiwis.stations.get(kiwis.selectedStationId.get());
        if (!station) {
            return null;
        }

        const options = kiwis.availableThresholds.get(timeSeries.id);
        if (!options || options.length === 0) {
            return null;
        }

        // evaluate title
        const optionsProcessed = options.map((opt) => {
            if (!opt.title) {
                return opt;
            }
            if (opt.title.indexOf("${") !== -1) {
                const title = opt.title.evaluate(station);
                const copy = _.clone(opt); // do not change value of observable here. make a copy
                copy.title = title ? String(title) : "";
                return copy;
            }
            return opt;
        });

        let selectedValues: string[] = [];
        if (kiwis.selectedThresholds.get(timeSeries.id)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            selectedValues = kiwis.selectedThresholds.get(timeSeries.id).slice();
        }

        const thresholdSelect =
            <Dropdown floating={false}
                selection multiple search clearable
                placeholder={"Schwellenwerte"}
                direction={"left"}
                additionPosition={"top"}
                options={optionsProcessed}
                defaultValue={selectedValues}
                renderLabel={this.renderLabel}
                onChange={this.onChange}/>;

        return (
            <div className={`thresholds ${compact ? "compact" : ""}`}>
                <div className="threshold-select">
                    <Form>
                        <Form.Field inline className={"ts-threshold-select"}>
                            {thresholdSelect}
                        </Form.Field>
                    </Form>
                </div>
            </div>
        );

    }

    private renderLabel(item: any) {
        return {
            className: item.value,
            content: item.text,
            title: item.title
        };
    }

}
